<template>
  <div>
   <v-row>
    <v-col cols="12" xs="12" sm="4">
    <v-select
      v-model="pointsToWin"
      :items="pointsToWinItems"
      ref="selectInput"
      outlined dense
      @change="updateSeries"
      :disabled="seriesSelected ? false : true"
      :no-data-text="$t('common.no_data')"
    ></v-select>
    </v-col>
   </v-row>
    <v-data-table 
      :headers="headers" 
      :items="rows" 
      class="elevation-1 ma-0 tableCust1"
      :footer-props="{
        'items-per-page-text': $t('dataTable.rowsPerPageText'),
        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
      }"
      :no-data-text="$t('dataTable.noDataText')"
      :headerProps="{
        'sort-by-text': $t('dataTable.sortByText')
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
            <v-btn-toggle dense>
              <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="newItem" :disabled="seriesSelected ? false : true">
                <v-icon left dark>fa-plus</v-icon>
                {{ $t('common.form.add') }}
              </v-btn> &nbsp;&nbsp;
              <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="importItem" :disabled="seriesSelected ? false : true">
                <v-icon left dark>far fa-file-import</v-icon>
                {{ $t('common.form.import') }}
              </v-btn>
              
              
            </v-btn-toggle>
            </template>
            <v-card class="borderDialog">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form ref="formSP" class="pt-4 inputSeries">
                  <v-row>
                    <v-col cols="12">
                    <v-text-field v-if="editorType == 'new' || editorType == 'edit'"
                      v-model="input.position"
                      ref="inputPosition"
                      :label="$t('page.series.position')"
                      :rules="[
                          (v) => $inputRules({value: v, minSize: 1, maxSize: 25}, 'fieldLength') || $t('page.series.position-invalid')
                      ]"
                      required
                      outlined dense
                      @keyup.enter="pressEnter"
                    ></v-text-field>
                    <v-text-field v-if="editorType == 'new' || editorType == 'edit'"
                      v-model="input.points"
                      ref="inputPoints"
                      :label="$t('page.series.points')"
                      required
                      outlined dense
                      type="number"
                      onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                      min="0"
                      @keyup.enter="pressEnter"
                      :rules="[
                          (v) => $inputRules({value: v}, 'integer') || $t('page.series.points-invalid')
                      ]"
                    ></v-text-field>
                    <v-text-field v-if="editorType == 'new' || editorType == 'edit'"
                      v-model="input.seriesYear"
                      ref="inputSeriesYear"
                      :label="$t('page.series.series-year')"
                      required
                      outlined dense
                      type="number"
                      onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                      min="1"
                      @keyup.enter="pressEnter"
                      :rules="[
                          (v) => $inputRules({value: v}, 'integer') || $t('page.series.seriesYear-invalid'),
                          (v) => $inputRules({value: v, minSize: 1, maxSize: 4}, 'fieldLength') || $t('page.series.seriesYear-invalid')
                      ]"
                    ></v-text-field>

                    <v-select v-if="editorType == 'import'"
                      v-model="seriesModel"
                      :items="seriesItems"
                      ref="selectInput"
                      outlined dense
                      required
                      :rules="[ v => !!v || $t('page.series.series-required')]"
                      @keyup.enter="importClasses"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>

                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="close">{{ $t('common.form.cancel') }}</v-btn>
                <v-btn v-if="editorType == 'new'" color="blue darken-1" small text @click="create">{{ $t('common.form.create') }}</v-btn>
                <v-btn v-if="editorType == 'edit'" color="blue darken-1" small text @click="save">{{ $t('common.form.update') }}</v-btn>
                <v-btn v-if="editorType == 'import'" color="blue darken-1" @click="importClasses" small text>{{ $t('common.form.import') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
      <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
      @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
      <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
  mixins: [apiCalls],
  properties: [],
  components: {
    SGSNotificationConfirm,
    SGSNotificationAlert
  },
  data() {
    return {
      pointsToWin: null,
      input: {
        class: null,
        group: null,
        groupItems: [],
        disableForSeries: null,
        eventsToCount: null,
        sortOrder: null
      },
      dialogNotification: false,
      alertMessage: '',
      dialogAlert: false,
      seriesModel: null,
      seriesItems: [],
      dialog: false,
      importDialog: true,
      reopenEdition: false,
      rows: [],
      item: {
        id: "",
        name: 0
      },
      editorType: "new"
    };
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
    formTitle() {
      let title = ''

      if (this.editorType == "new") title = this.$t('page.series.add-points-schedule')
      if (this.editorType == "edit") title = this.$t('page.series.edit-points-schedule')
      if (this.editorType == "import") title = this.$t('page.series.import-points-schedule')
      
      return title
    },
    pointsToWinItems() {
      return [
        {text: this.$t('page.series.most-points-win'), value: 1},
        {text: this.$t('page.series.least-points-win'), value: 2}
      ];
    },
    headers() {
      return [
        {
          text: this.$t("page.series.position"),
          value: "position"
        },
        {
          text: this.$t("page.series.points"),
          value: "points"
        },
        {
          text: this.$t("page.series.series-year"),
          value: "seriesYear"
        },
        {
          text: this.$t("common.table.actions"),
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    seriesSelected() {
      
      this.getRecords();

      if(this.seriesSelected) {
        const placementOrder = this.seriesSelected.placementOrder;
        this.pointsToWin = placementOrder;
      }
    }
  },
  methods: {
    init()
    {
      this.getRecords();

      if(this.seriesSelected) {
        const placementOrder = this.seriesSelected.placementOrder;
        this.pointsToWin = placementOrder;
      }
    },
    pressEnter(){
      if(this.editorType == "edit"){
        this.save()
      }else{
        this.create()
      }
    },
    async getRecords() {
      if(this.seriesSelected) {
        const response = await this.api(
          'get',
          `/api/v1/promoter/series/${this.seriesSelected.id}/pointsScheadule`
        );

        this.rows = [];
        if(!response || !response.success)
        {
          return;
        }

        response.message.data.forEach((element) => {

          const row = { 
            id: element.id, 
            position: element.position,
            points: element.points,
            seriesYear: element.seriesYear,

            actions: "actions"
          };
          
          this.rows.push(row);
        });

        this.getSeries();
        this.getGroups();
      }
    },
    async getSeries() {
      if(this.seriesSelected) {
        const response = await this.getApi(
          "/api/v1/promoter/series"
        );

        if (response != undefined) {        
          for(var i = 0; i < response.length; i++){
            if(response[i].id == this.seriesSelected.id){
              continue;
            }
            this.seriesItems.push({
              text: response[i].seriesName,
              value: response[i].id
            });          
          }
          this.allSeries = response;
        }
      }
    },
    resetForm(){
      
        this.input.position = null;
        this.input.points = null;
        this.input.seriesYear = null;
    },
    setForm(item){      
        
        this.input.id = item.id;
        this.input.position = item.position;
        this.input.points = item.points;
        this.input.seriesYear = item.seriesYear;
      
    },
    newItem() {
      this.resetForm();
      this.input.seriesYear = new Date().getFullYear();
      this.editorType = "new";
      if(this.$refs.formSP)
        this.$refs.formSP.resetValidation();
    },
    importItem(){
      if(this.$refs.formSP)
        this.$refs.formSP.resetValidation();
      this.editorType = "import";
      this.dialog =  true
    },
    editItem(item){
      this.resetForm();
      this.setForm(item);
      this.editorType = "edit";
      this.dialog = true;
      this.item.id = item.id;
    },
    confirmDelete(item){
      this.dialogNotification = true
      this.item = item
    },
    async deleteItem() 
    {
        const response = await this.api('DELETE', `/api/v1/promoter/series/pointsScheadule/${this.item.id}`);      
      
        if(response != undefined){
          if(!response.success) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.error) && response.error.length > 0) {
                this.alertMessage = this.$t('common.request.'+response.error[0]);
            } else if(typeof response.error == 'string') {
                this.alertMessage = this.$t('common.request.'+response.error)
            } else if(Array.isArray(response.message) && response.message.length > 0) {
                this.alertMessage = this.$t('common.request.'+response.message[0]);
            } else if(typeof response.message == 'string') {
                this.alertMessage = this.$t('common.request.'+response.message)
            }
            this.dialog = false;
            this.dialogAlert = true;
            return;
          }
          this.getRecords();
          this.close();
        }  else {
          this.alertMessage = this.$t('page.series.error_general');
          this.dialog = false;
          this.dialogAlert = true;
        }
    },
    close() {
      this.dialog = false;
      this.dialogNotification = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async create()
    {
      if (!this.$refs.formSP.validate())
      {
        return false;
      }

      let data = {};
      data.seriesId = this.seriesSelected.id;
      data.position = this.input.position;
      data.points = this.input.points;
      data.seriesYear = parseInt(this.input.seriesYear);

      const response = await this.api("POST", "/api/v1/promoter/series/pointsScheadule", data);

      if (response == undefined)
      {
        this.alertMessage = this.$t('page.series.error_general');
        this.dialog = false;
        this.dialogAlert = true;
        this.reopenEdition = true;
      }

      if (!response.success)
      {
        this.alertMessage = this.$t('page.series.error_general');
        if (Array.isArray(response.error) && response.error.length > 0)
        {
          this.alertMessage = this.$t('common.request.' + response.error[0]);
        } else if (typeof response.error == 'string')
        {
          this.alertMessage = this.$t('common.request.' + response.error)
        } else if (Array.isArray(response.message) && response.message.length > 0)
        {
          this.alertMessage = this.$t('common.request.' + response.message[0]);
        } else if (typeof response.message == 'string')
        {
          this.alertMessage = this.$t('common.request.' + response.message)
        }
        this.dialog = false;
        this.dialogAlert = true;
        this.reopenEdition = true;
        return;
      }

      this.init();
      this.close();
    },
    async importClasses(){

      if(!this.$refs.formSP.validate()) {
        if(this.seriesModel == null || this.seriesModel == ''){
          this.$refs.selectInput.focus();
          return false;
        }
        return;
      }

      this.dialog = false

      let data = {
        seriesId: this.seriesSelected.id,
        targetSeriesId: this.seriesModel
      }

      const response = await this.api("POST", "/api/v1/promoter/series/pointsScheadule/import", data);

      if(!response || !response.success){ 
          this.alertMessage = this.$t('page.series.error_general');
          if(response && Array.isArray(response.error) && response.error.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.error[0]);
          } else if(response && typeof response.error == 'string') {
              this.alertMessage = this.$t('common.request.'+response.error)
          } else if(response && Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.message[0]);
          } else if(response && typeof response.message == 'string') {
              this.alertMessage = this.$t('common.request.'+response.message)
          }
          this.dialog = false;
          this.dialogAlert = true;
          this.reopenEdition = true;
          return; 
      }

      this.init();
      this.close();
    },
    async save()
    {
      if(!this.$refs.formSP.validate()) {
        return false;
      }

     let data = {};
      data.id = this.input.id;
      data.position = this.input.position;    
      data.points = this.input.points;    
      data.seriesYear = parseInt(this.input.seriesYear);

      const response = await this.api("PUT", "/api/v1/promoter/series/pointsScheadule", data);
      
      if (response != undefined) {
            if(!response.success) {
              this.alertMessage = this.$t('page.series.error_general');
              if(Array.isArray(response.error) && response.error.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.error[0]);
              } else if(typeof response.error == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.error)
              } else if(Array.isArray(response.message) && response.message.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.message[0]);
              } else if(typeof response.message == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.message)
              }
              this.dialog = false;
              this.dialogAlert = true;
              this.reopenEdition = true;
              return;
            }

            this.init();
            this.close();
      } else {
            this.alertMessage = this.$t('page.series.error_general');
            this.dialog = false;
            this.dialogAlert = true;
            this.reopenEdition = true;
      }

    },
    closeAlert(){
      this.dialogAlert=false;
      if(this.reopenEdition){
        this.dialog = true;
      }
    },
    async getGroups() {
      if(this.seriesSelected) {
        const response = await this.api('get',`/api/v1/promoter/series/group/${this.seriesSelected.id}`);

        this.input.groupItems = [];
        response.message.data.forEach(element => {
          const item = { value: element.id, text: element.groupName };
          this.input.groupItems.push(item);
        });
      }
    },
    async updateSeries(value){
      let data = {};
      data.placementOrder = value;
      data.seriesId = this.seriesSelected.id;

      const response = await this.api("PUT", "/api/v1/promoter/series/update", data);

      if (response != undefined) {
            if(response.success) {
              try {
                if(response.message == 1){
                  this.seriesSelected.placementOrder = value
                }
              } catch(e) {/**/}
            } else if(!response.success) {
              this.alertMessage = this.$t('page.series.error_general');
              if(Array.isArray(response.error) && response.error.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.error[0]);
              } else if(typeof response.error == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.error)
              } else if(Array.isArray(response.message) && response.message.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.message[0]);
              } else if(typeof response.message == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.message)
              }
              this.dialogAlert = true;
              return;
            }

            this.init();
            this.close();
      } else {
            this.alertMessage = this.$t('page.series.error_general');
            this.dialogAlert = true;
      }
    }
  }
};
</script>

<style scoped>
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
    padding: 0 40px 20px;
}
.v-card__actions .v-btn {
    background-color: var(--v-primary-darken2) !important;
    color: white !important;
}
.v-text-field.v-text-field--enclosed {
    padding-top: 12px;
    margin-top: 4px;
}
</style>
